<template>
    <div class="saas-page linear-admin-workflow">
        <div class="saas-hero card-saas linear-page-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <router-link to="/todo">{{ trans('todo.todo') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{trans('todo.edit_todo')}}</span>
                </p>
                <h1 class="saas-hero__title">{{trans('todo.edit_todo')}}</h1>
                <p class="linear-page-copy">{{trans('todo.todo')}}</p>
            </div>
        </div>
        <div class="row linear-admin-workflow__grid">
            <div class="col-12 col-lg-7">
                <div class="card-saas linear-admin-panel">
                    <todo-form :id="id"></todo-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import todoForm from './form';

    export default {
        components : { todoForm },
        data() {
            return {
                id:this.$route.params.id
            }
        },
        mounted(){
            if(!helper.hasPermission('access-todo')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('todo')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }
        }
    }
</script>

<style scoped>
.linear-page-hero {
    align-items: center;
}

.linear-eyebrow,
.linear-section-head span {
    color: #635bff;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-page-copy {
    margin: 0.45rem 0 0;
    color: #64748b;
    font-size: 0.875rem;
}

.linear-admin-workflow__grid {
    justify-content: center;
}

.linear-admin-panel {
    padding: 1.15rem;
}

.linear-section-head {
    margin-bottom: 1rem;
}

.linear-section-head h4 {
    margin: 0.25rem 0 0;
    color: #0f172a;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

@media (max-width: 575.98px) {
    .linear-page-hero {
        align-items: flex-start;
    }
}
</style>
